import { useTranslation } from 'react-i18next'

import { LogoutIcon } from 'app/common/presentation/icons'
import { getInitials } from 'app/common/presentation/initials'
import { useUser } from 'app/user/application'

import { Avatar, IconButton } from 'components'

import styles from './Sidebar.module.scss'

const UserInfo = () => {
  const { t } = useTranslation('sidebar')
  const { logout, user } = useUser()

  if (!user) {
    return null
  }

  return (
    <div className={styles.user}>
      <Avatar className={styles.avatar} initials={getInitials(user)} />
      <div className={styles.userDetails}>
        <span className={styles.userName}>{`${user.firstName} ${user.lastName}`}</span>
        <span className={styles.userEmail}>{user.email}</span>
      </div>
      <IconButton
        aria-label={t('profile.menu.logout')}
        icon={LogoutIcon}
        onClick={() => void logout()}
        small
        type="button"
        variant="tertiary"
      />
    </div>
  )
}

export default UserInfo
